import type { Dayjs } from 'dayjs';

import { CHART_TERM_UNIT } from '@/entities/chart/model/constants';
import { getTimezoneDayjs } from '@/utils/time';

import {
  DASHBOARD_DATE_FILTER_TYPE,
  DASHBOARD_DATE_FILTER_UNIT,
} from './constants';

export const getDateRange = (
  type: DASHBOARD_DATE_FILTER_TYPE,
): [Dayjs, Dayjs] | null => {
  switch (type) {
    case DASHBOARD_DATE_FILTER_TYPE.LAST_7_DAYS:
      return [
        getTimezoneDayjs().subtractVal(6, 'day').startOf('day'),
        getTimezoneDayjs().endOf('day'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_14_DAYS:
      return [
        getTimezoneDayjs().subtractVal(13, 'day').startOf('day'),
        getTimezoneDayjs().endOf('day'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_30_DAYS:
      return [
        getTimezoneDayjs().subtractVal(29, 'day').startOf('day'),
        getTimezoneDayjs().endOf('day'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_4_WEEKS:
      return [
        getTimezoneDayjs().subtractVal(3, 'week').startOf('week'),
        getTimezoneDayjs().endOf('week'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_8_WEEKS:
      return [
        getTimezoneDayjs().subtractVal(7, 'week').startOf('week'),
        getTimezoneDayjs().endOf('week'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_12_WEEKS:
      return [
        getTimezoneDayjs().subtractVal(11, 'week').startOf('week'),
        getTimezoneDayjs().endOf('week'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_3_MONTHS:
      return [
        getTimezoneDayjs().subtractVal(2, 'month').startOf('month'),
        getTimezoneDayjs().endOf('month'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_6_MONTHS:
      return [
        getTimezoneDayjs().subtractVal(5, 'month').startOf('month'),
        getTimezoneDayjs().endOf('month'),
      ];
    case DASHBOARD_DATE_FILTER_TYPE.LAST_12_MONTHS:
      return [
        getTimezoneDayjs().subtractVal(11, 'month').startOf('month'),
        getTimezoneDayjs().endOf('month'),
      ];
    default:
      return null;
  }
};

export const getAdjustDateRangeByUnit = (
  unit: DASHBOARD_DATE_FILTER_UNIT,
  dateRange: [Dayjs, Dayjs] | null,
): [Dayjs, Dayjs] | null => {
  if (!dateRange) return null;
  switch (unit) {
    case DASHBOARD_DATE_FILTER_UNIT.DAY:
      return [dateRange[0].startOf('day'), dateRange[1].endOf('day')];
    case DASHBOARD_DATE_FILTER_UNIT.WEEK:
      return [dateRange[0].startOf('week'), dateRange[1].endOf('week')];
    case DASHBOARD_DATE_FILTER_UNIT.MONTH:
      return [dateRange[0].startOf('month'), dateRange[1].endOf('month')];
  }
};

export const convertDashboardDateFilterUnitToChartTermUnit = (
  unit: DASHBOARD_DATE_FILTER_UNIT,
): CHART_TERM_UNIT => {
  switch (unit) {
    case DASHBOARD_DATE_FILTER_UNIT.DAY:
      return CHART_TERM_UNIT.DAY;
    case DASHBOARD_DATE_FILTER_UNIT.WEEK:
      return CHART_TERM_UNIT.WEEK;
    case DASHBOARD_DATE_FILTER_UNIT.MONTH:
      return CHART_TERM_UNIT.MONTH;
  }
};
